/**
 * Cross-model benchmarks, generated from our own EPA/manufacturer tables
 * (August 2026 snapshot). Used to give each attribute page a real comparative
 * anchor — rank, cohort median and the nearest rival above and below — instead
 * of describing its numbers in isolation.
 */

export interface Benchmark {
  value: number;
  rank: number;
  n: number;
  median: number;
  cls?: string;
  above: [string, number] | null;
  below: [string, number] | null;
  ties?: string[];
}

export const TOWING_BENCH: Record<string, Benchmark> = {
  "ford/f350": {
    "value": 40000.0,
    "rank": 1,
    "n": 51,
    "median": 5600.0,
    "above": null,
    "below": [
      "Ford F-250",
      23000.0
    ],
    "ties": []
  },
  "ford/f250": {
    "value": 23000.0,
    "rank": 2,
    "n": 51,
    "median": 5600.0,
    "above": [
      "Ford F-350",
      40000.0
    ],
    "below": [
      "Ford F-150",
      14000.0
    ],
    "ties": []
  },
  "ford/f150": {
    "value": 14000.0,
    "rank": 3,
    "n": 51,
    "median": 5600.0,
    "above": [
      "Ford F-250",
      23000.0
    ],
    "below": [
      "Chevrolet Silverado",
      13300.0
    ],
    "ties": []
  },
  "chevrolet/silverado": {
    "value": 13300.0,
    "rank": 4,
    "n": 51,
    "median": 5600.0,
    "above": [
      "Ford F-150",
      14000.0
    ],
    "below": [
      "GMC Sierra",
      13200.0
    ],
    "ties": []
  },
  "gmc/sierra": {
    "value": 13200.0,
    "rank": 5,
    "n": 51,
    "median": 5600.0,
    "above": [
      "Chevrolet Silverado",
      13300.0
    ],
    "below": [
      "Ram 1500",
      12750.0
    ],
    "ties": []
  },
  "ram/1500": {
    "value": 12750.0,
    "rank": 6,
    "n": 51,
    "median": 5600.0,
    "above": [
      "GMC Sierra",
      13200.0
    ],
    "below": [
      "Toyota Tundra",
      12000.0
    ],
    "ties": []
  },
  "toyota/tundra": {
    "value": 12000.0,
    "rank": 7,
    "n": 51,
    "median": 5600.0,
    "above": [
      "Ram 1500",
      12750.0
    ],
    "below": [
      "Ford F-150 Lightning",
      10000.0
    ],
    "ties": []
  },
  "ford/f-150-lightning": {
    "value": 10000.0,
    "rank": 8,
    "n": 51,
    "median": 5600.0,
    "above": [
      "Toyota Tundra",
      12000.0
    ],
    "below": [
      "Toyota Sequoia",
      9520.0
    ],
    "ties": []
  },
  "toyota/sequoia": {
    "value": 9520.0,
    "rank": 9,
    "n": 51,
    "median": 5600.0,
    "above": [
      "Ford F-150 Lightning",
      10000.0
    ],
    "below": [
      "Nissan Titan",
      9310.0
    ],
    "ties": []
  },
  "nissan/titan": {
    "value": 9310.0,
    "rank": 10,
    "n": 51,
    "median": 5600.0,
    "above": [
      "Toyota Sequoia",
      9520.0
    ],
    "below": [
      "Ford Expedition",
      9300.0
    ],
    "ties": []
  },
  "ford/expedition": {
    "value": 9300.0,
    "rank": 11,
    "n": 51,
    "median": 5600.0,
    "above": [
      "Nissan Titan",
      9310.0
    ],
    "below": [
      "Dodge Durango",
      8700.0
    ],
    "ties": []
  },
  "dodge/durango": {
    "value": 8700.0,
    "rank": 12,
    "n": 51,
    "median": 5600.0,
    "above": [
      "Ford Expedition",
      9300.0
    ],
    "below": [
      "Chevrolet Tahoe",
      8600.0
    ],
    "ties": []
  },
  "chevrolet/tahoe": {
    "value": 8600.0,
    "rank": 13,
    "n": 51,
    "median": 5600.0,
    "above": [
      "Dodge Durango",
      8700.0
    ],
    "below": [
      "GMC Yukon",
      8500.0
    ],
    "ties": []
  },
  "gmc/yukon": {
    "value": 8500.0,
    "rank": 14,
    "n": 51,
    "median": 5600.0,
    "above": [
      "Chevrolet Tahoe",
      8600.0
    ],
    "below": [
      "Chevrolet Suburban",
      8300.0
    ],
    "ties": [
      "Nissan Armada"
    ]
  },
  "nissan/armada": {
    "value": 8500.0,
    "rank": 15,
    "n": 51,
    "median": 5600.0,
    "above": [
      "Chevrolet Tahoe",
      8600.0
    ],
    "below": [
      "Chevrolet Suburban",
      8300.0
    ],
    "ties": [
      "GMC Yukon"
    ]
  },
  "chevrolet/suburban": {
    "value": 8300.0,
    "rank": 16,
    "n": 51,
    "median": 5600.0,
    "above": [
      "Nissan Armada",
      8500.0
    ],
    "below": [
      "GMC Canyon",
      7700.0
    ],
    "ties": []
  },
  "gmc/canyon": {
    "value": 7700.0,
    "rank": 17,
    "n": 51,
    "median": 5600.0,
    "above": [
      "Chevrolet Suburban",
      8300.0
    ],
    "below": [
      "Jeep Gladiator",
      7650.0
    ],
    "ties": [
      "Chevrolet Colorado"
    ]
  },
  "chevrolet/colorado": {
    "value": 7700.0,
    "rank": 18,
    "n": 51,
    "median": 5600.0,
    "above": [
      "Chevrolet Suburban",
      8300.0
    ],
    "below": [
      "Jeep Gladiator",
      7650.0
    ],
    "ties": [
      "GMC Canyon"
    ]
  },
  "jeep/gladiator": {
    "value": 7650.0,
    "rank": 19,
    "n": 51,
    "median": 5600.0,
    "above": [
      "Chevrolet Colorado",
      7700.0
    ],
    "below": [
      "Ford Ranger",
      7500.0
    ],
    "ties": []
  },
  "ford/ranger": {
    "value": 7500.0,
    "rank": 20,
    "n": 51,
    "median": 5600.0,
    "above": [
      "Jeep Gladiator",
      7650.0
    ],
    "below": [
      "Jeep Grand Cherokee",
      7200.0
    ],
    "ties": []
  },
  "jeep/grand-cherokee": {
    "value": 7200.0,
    "rank": 21,
    "n": 51,
    "median": 5600.0,
    "above": [
      "Ford Ranger",
      7500.0
    ],
    "below": [
      "Toyota Tacoma",
      6800.0
    ],
    "ties": []
  },
  "toyota/tacoma": {
    "value": 6800.0,
    "rank": 22,
    "n": 51,
    "median": 5600.0,
    "above": [
      "Jeep Grand Cherokee",
      7200.0
    ],
    "below": [
      "Nissan Frontier",
      6720.0
    ],
    "ties": []
  },
  "nissan/frontier": {
    "value": 6720.0,
    "rank": 23,
    "n": 51,
    "median": 5600.0,
    "above": [
      "Toyota Tacoma",
      6800.0
    ],
    "below": [
      "Nissan Pathfinder",
      6000.0
    ],
    "ties": []
  },
  "nissan/pathfinder": {
    "value": 6000.0,
    "rank": 24,
    "n": 51,
    "median": 5600.0,
    "above": [
      "Nissan Frontier",
      6720.0
    ],
    "below": [
      "Ford Explorer",
      5600.0
    ],
    "ties": [
      "Toyota 4Runner"
    ]
  },
  "toyota/4runner": {
    "value": 6000.0,
    "rank": 25,
    "n": 51,
    "median": 5600.0,
    "above": [
      "Nissan Frontier",
      6720.0
    ],
    "below": [
      "Ford Explorer",
      5600.0
    ],
    "ties": [
      "Nissan Pathfinder"
    ]
  },
  "ford/explorer": {
    "value": 5600.0,
    "rank": 26,
    "n": 51,
    "median": 5600.0,
    "above": [
      "Toyota 4Runner",
      6000.0
    ],
    "below": [
      "Hyundai Palisade",
      5000.0
    ],
    "ties": []
  },
  "hyundai/palisade": {
    "value": 5000.0,
    "rank": 27,
    "n": 51,
    "median": 5600.0,
    "above": [
      "Ford Explorer",
      5600.0
    ],
    "below": [
      "Kia Sorento",
      3500.0
    ],
    "ties": [
      "Kia Telluride",
      "Chevrolet Traverse",
      "Subaru Ascent"
    ]
  },
  "kia/telluride": {
    "value": 5000.0,
    "rank": 28,
    "n": 51,
    "median": 5600.0,
    "above": [
      "Ford Explorer",
      5600.0
    ],
    "below": [
      "Kia Sorento",
      3500.0
    ],
    "ties": [
      "Hyundai Palisade",
      "Chevrolet Traverse",
      "Subaru Ascent"
    ]
  },
  "chevrolet/traverse": {
    "value": 5000.0,
    "rank": 29,
    "n": 51,
    "median": 5600.0,
    "above": [
      "Ford Explorer",
      5600.0
    ],
    "below": [
      "Kia Sorento",
      3500.0
    ],
    "ties": [
      "Hyundai Palisade",
      "Kia Telluride",
      "Subaru Ascent"
    ]
  },
  "subaru/ascent": {
    "value": 5000.0,
    "rank": 30,
    "n": 51,
    "median": 5600.0,
    "above": [
      "Ford Explorer",
      5600.0
    ],
    "below": [
      "Kia Sorento",
      3500.0
    ],
    "ties": [
      "Hyundai Palisade",
      "Kia Telluride",
      "Chevrolet Traverse"
    ]
  },
  "toyota/highlander": {
    "value": 5000.0,
    "rank": 31,
    "n": 51,
    "median": 5600.0,
    "above": [
      "Ford Explorer",
      5600.0
    ],
    "below": [
      "Kia Sorento",
      3500.0
    ],
    "ties": [
      "Hyundai Palisade",
      "Kia Telluride",
      "Chevrolet Traverse"
    ]
  },
  "honda/pilot": {
    "value": 5000.0,
    "rank": 32,
    "n": 51,
    "median": 5600.0,
    "above": [
      "Ford Explorer",
      5600.0
    ],
    "below": [
      "Kia Sorento",
      3500.0
    ],
    "ties": [
      "Hyundai Palisade",
      "Kia Telluride",
      "Chevrolet Traverse"
    ]
  },
  "honda/ridgeline": {
    "value": 5000.0,
    "rank": 33,
    "n": 51,
    "median": 5600.0,
    "above": [
      "Ford Explorer",
      5600.0
    ],
    "below": [
      "Kia Sorento",
      3500.0
    ],
    "ties": [
      "Hyundai Palisade",
      "Kia Telluride",
      "Chevrolet Traverse"
    ]
  },
  "volkswagen/atlas": {
    "value": 5000.0,
    "rank": 34,
    "n": 51,
    "median": 5600.0,
    "above": [
      "Ford Explorer",
      5600.0
    ],
    "below": [
      "Kia Sorento",
      3500.0
    ],
    "ties": [
      "Hyundai Palisade",
      "Kia Telluride",
      "Chevrolet Traverse"
    ]
  },
  "kia/sorento": {
    "value": 3500.0,
    "rank": 35,
    "n": 51,
    "median": 5600.0,
    "above": [
      "Volkswagen Atlas",
      5000.0
    ],
    "below": [
      "Mazda CX-5",
      2000.0
    ],
    "ties": [
      "Ford Edge",
      "Jeep Wrangler",
      "Ford Bronco"
    ]
  },
  "ford/edge": {
    "value": 3500.0,
    "rank": 36,
    "n": 51,
    "median": 5600.0,
    "above": [
      "Volkswagen Atlas",
      5000.0
    ],
    "below": [
      "Mazda CX-5",
      2000.0
    ],
    "ties": [
      "Kia Sorento",
      "Jeep Wrangler",
      "Ford Bronco"
    ]
  },
  "jeep/wrangler": {
    "value": 3500.0,
    "rank": 37,
    "n": 51,
    "median": 5600.0,
    "above": [
      "Volkswagen Atlas",
      5000.0
    ],
    "below": [
      "Mazda CX-5",
      2000.0
    ],
    "ties": [
      "Kia Sorento",
      "Ford Edge",
      "Ford Bronco"
    ]
  },
  "ford/bronco": {
    "value": 3500.0,
    "rank": 38,
    "n": 51,
    "median": 5600.0,
    "above": [
      "Volkswagen Atlas",
      5000.0
    ],
    "below": [
      "Mazda CX-5",
      2000.0
    ],
    "ties": [
      "Kia Sorento",
      "Ford Edge",
      "Jeep Wrangler"
    ]
  },
  "toyota/sienna": {
    "value": 3500.0,
    "rank": 39,
    "n": 51,
    "median": 5600.0,
    "above": [
      "Volkswagen Atlas",
      5000.0
    ],
    "below": [
      "Mazda CX-5",
      2000.0
    ],
    "ties": [
      "Kia Sorento",
      "Ford Edge",
      "Jeep Wrangler"
    ]
  },
  "subaru/outback": {
    "value": 3500.0,
    "rank": 40,
    "n": 51,
    "median": 5600.0,
    "above": [
      "Volkswagen Atlas",
      5000.0
    ],
    "below": [
      "Mazda CX-5",
      2000.0
    ],
    "ties": [
      "Kia Sorento",
      "Ford Edge",
      "Jeep Wrangler"
    ]
  },
  "honda/odyssey": {
    "value": 3500.0,
    "rank": 41,
    "n": 51,
    "median": 5600.0,
    "above": [
      "Volkswagen Atlas",
      5000.0
    ],
    "below": [
      "Mazda CX-5",
      2000.0
    ],
    "ties": [
      "Kia Sorento",
      "Ford Edge",
      "Jeep Wrangler"
    ]
  },
  "toyota/rav4": {
    "value": 3500.0,
    "rank": 42,
    "n": 51,
    "median": 5600.0,
    "above": [
      "Volkswagen Atlas",
      5000.0
    ],
    "below": [
      "Mazda CX-5",
      2000.0
    ],
    "ties": [
      "Kia Sorento",
      "Ford Edge",
      "Jeep Wrangler"
    ]
  },
  "ford/escape": {
    "value": 3500.0,
    "rank": 43,
    "n": 51,
    "median": 5600.0,
    "above": [
      "Volkswagen Atlas",
      5000.0
    ],
    "below": [
      "Mazda CX-5",
      2000.0
    ],
    "ties": [
      "Kia Sorento",
      "Ford Edge",
      "Jeep Wrangler"
    ]
  },
  "mazda/cx-9": {
    "value": 3500.0,
    "rank": 44,
    "n": 51,
    "median": 5600.0,
    "above": [
      "Volkswagen Atlas",
      5000.0
    ],
    "below": [
      "Mazda CX-5",
      2000.0
    ],
    "ties": [
      "Kia Sorento",
      "Ford Edge",
      "Jeep Wrangler"
    ]
  },
  "hyundai/santa-fe": {
    "value": 3500.0,
    "rank": 45,
    "n": 51,
    "median": 5600.0,
    "above": [
      "Volkswagen Atlas",
      5000.0
    ],
    "below": [
      "Mazda CX-5",
      2000.0
    ],
    "ties": [
      "Kia Sorento",
      "Ford Edge",
      "Jeep Wrangler"
    ]
  },
  "mazda/cx-5": {
    "value": 2000.0,
    "rank": 46,
    "n": 51,
    "median": 5600.0,
    "above": [
      "Hyundai Santa Fe",
      3500.0
    ],
    "below": [
      "Chevrolet Equinox",
      1500.0
    ],
    "ties": []
  },
  "chevrolet/equinox": {
    "value": 1500.0,
    "rank": 47,
    "n": 51,
    "median": 5600.0,
    "above": [
      "Mazda CX-5",
      2000.0
    ],
    "below": [
      "Nissan Rogue",
      1350.0
    ],
    "ties": [
      "Honda CR-V",
      "Nissan Murano",
      "Subaru Forester"
    ]
  },
  "honda/cr-v": {
    "value": 1500.0,
    "rank": 48,
    "n": 51,
    "median": 5600.0,
    "above": [
      "Mazda CX-5",
      2000.0
    ],
    "below": [
      "Nissan Rogue",
      1350.0
    ],
    "ties": [
      "Chevrolet Equinox",
      "Nissan Murano",
      "Subaru Forester"
    ]
  },
  "nissan/murano": {
    "value": 1500.0,
    "rank": 49,
    "n": 51,
    "median": 5600.0,
    "above": [
      "Mazda CX-5",
      2000.0
    ],
    "below": [
      "Nissan Rogue",
      1350.0
    ],
    "ties": [
      "Chevrolet Equinox",
      "Honda CR-V",
      "Subaru Forester"
    ]
  },
  "subaru/forester": {
    "value": 1500.0,
    "rank": 50,
    "n": 51,
    "median": 5600.0,
    "above": [
      "Mazda CX-5",
      2000.0
    ],
    "below": [
      "Nissan Rogue",
      1350.0
    ],
    "ties": [
      "Chevrolet Equinox",
      "Honda CR-V",
      "Nissan Murano"
    ]
  },
  "nissan/rogue": {
    "value": 1350.0,
    "rank": 51,
    "n": 51,
    "median": 5600.0,
    "above": [
      "Subaru Forester",
      1500.0
    ],
    "below": null,
    "ties": []
  }
};

export const BED_BENCH: Record<string, Benchmark> = {
  "chevrolet/silverado": {
    "value": 98.2,
    "rank": 1,
    "n": 17,
    "median": 74.0,
    "above": null,
    "below": [
      "Ford F-350",
      98.1
    ],
    "ties": [
      "GMC Sierra"
    ]
  },
  "gmc/sierra": {
    "value": 98.2,
    "rank": 2,
    "n": 17,
    "median": 74.0,
    "above": null,
    "below": [
      "Ford F-350",
      98.1
    ],
    "ties": [
      "Chevrolet Silverado"
    ]
  },
  "ford/f350": {
    "value": 98.1,
    "rank": 3,
    "n": 17,
    "median": 74.0,
    "above": [
      "GMC Sierra",
      98.2
    ],
    "below": [
      "Ford F-150",
      97.6
    ],
    "ties": [
      "Ford F-250"
    ]
  },
  "ford/f250": {
    "value": 98.1,
    "rank": 4,
    "n": 17,
    "median": 74.0,
    "above": [
      "GMC Sierra",
      98.2
    ],
    "below": [
      "Ford F-150",
      97.6
    ],
    "ties": [
      "Ford F-350"
    ]
  },
  "ford/f150": {
    "value": 97.6,
    "rank": 5,
    "n": 17,
    "median": 74.0,
    "above": [
      "Ford F-250",
      98.1
    ],
    "below": [
      "Nissan Titan",
      96.6
    ],
    "ties": [
      "Toyota Tundra"
    ]
  },
  "toyota/tundra": {
    "value": 97.6,
    "rank": 6,
    "n": 17,
    "median": 74.0,
    "above": [
      "Ford F-250",
      98.1
    ],
    "below": [
      "Nissan Titan",
      96.6
    ],
    "ties": [
      "Ford F-150"
    ]
  },
  "nissan/titan": {
    "value": 96.6,
    "rank": 7,
    "n": 17,
    "median": 74.0,
    "above": [
      "Toyota Tundra",
      97.6
    ],
    "below": [
      "Ram 1500",
      76.3
    ],
    "ties": []
  },
  "ram/1500": {
    "value": 76.3,
    "rank": 8,
    "n": 17,
    "median": 74.0,
    "above": [
      "Nissan Titan",
      96.6
    ],
    "below": [
      "GMC Canyon",
      74.0
    ],
    "ties": []
  },
  "gmc/canyon": {
    "value": 74.0,
    "rank": 9,
    "n": 17,
    "median": 74.0,
    "above": [
      "Ram 1500",
      76.3
    ],
    "below": [
      "Toyota Tacoma",
      73.9
    ],
    "ties": [
      "Chevrolet Colorado"
    ]
  },
  "chevrolet/colorado": {
    "value": 74.0,
    "rank": 10,
    "n": 17,
    "median": 74.0,
    "above": [
      "Ram 1500",
      76.3
    ],
    "below": [
      "Toyota Tacoma",
      73.9
    ],
    "ties": [
      "GMC Canyon"
    ]
  },
  "toyota/tacoma": {
    "value": 73.9,
    "rank": 11,
    "n": 17,
    "median": 74.0,
    "above": [
      "Chevrolet Colorado",
      74.0
    ],
    "below": [
      "Nissan Frontier",
      73.3
    ],
    "ties": []
  },
  "nissan/frontier": {
    "value": 73.3,
    "rank": 12,
    "n": 17,
    "median": 74.0,
    "above": [
      "Toyota Tacoma",
      73.9
    ],
    "below": [
      "Ford F-150 Lightning",
      67.1
    ],
    "ties": []
  },
  "ford/f-150-lightning": {
    "value": 67.1,
    "rank": 13,
    "n": 17,
    "median": 74.0,
    "above": [
      "Nissan Frontier",
      73.3
    ],
    "below": [
      "Honda Ridgeline",
      63.6
    ],
    "ties": []
  },
  "honda/ridgeline": {
    "value": 63.6,
    "rank": 14,
    "n": 17,
    "median": 74.0,
    "above": [
      "Ford F-150 Lightning",
      67.1
    ],
    "below": [
      "Ford Ranger",
      61.0
    ],
    "ties": []
  },
  "ford/ranger": {
    "value": 61.0,
    "rank": 15,
    "n": 17,
    "median": 74.0,
    "above": [
      "Honda Ridgeline",
      63.6
    ],
    "below": [
      "Jeep Gladiator",
      60.3
    ],
    "ties": []
  },
  "jeep/gladiator": {
    "value": 60.3,
    "rank": 16,
    "n": 17,
    "median": 74.0,
    "above": [
      "Ford Ranger",
      61.0
    ],
    "below": [
      "Ford Maverick",
      54.4
    ],
    "ties": []
  },
  "ford/maverick": {
    "value": 54.4,
    "rank": 17,
    "n": 17,
    "median": 74.0,
    "above": [
      "Jeep Gladiator",
      60.3
    ],
    "below": null,
    "ties": []
  }
};

export const MPG_BENCH: Record<string, Benchmark> = {
  "toyota/camry": {
    "value": 52,
    "cls": "Midsize Cars",
    "rank": 4,
    "n": 55,
    "median": 30.0,
    "above": [
      "Hyundai Elantra",
      54
    ],
    "below": [
      "Honda Accord",
      48
    ]
  },
  "honda/accord": {
    "value": 48,
    "cls": "Midsize Cars",
    "rank": 5,
    "n": 55,
    "median": 30.0,
    "above": [
      "Toyota Camry",
      52
    ],
    "below": [
      "Chevrolet Malibu",
      46
    ]
  },
  "toyota/tacoma": {
    "value": 24,
    "cls": "Small Pickup Trucks 4WD",
    "rank": 1,
    "n": 1,
    "median": 24.0,
    "above": null,
    "below": null
  },
  "ford/escape": {
    "value": 41,
    "cls": "Small Sport Utility Vehicle 2WD",
    "rank": 4,
    "n": 18,
    "median": 31.5,
    "above": [
      "Hyundai Tucson",
      50
    ],
    "below": [
      "Kia Sorento",
      37
    ]
  },
  "toyota/rav4": {
    "value": 43,
    "cls": "Small Sport Utility Vehicle 4WD",
    "rank": 1,
    "n": 70,
    "median": 27.0,
    "above": null,
    "below": [
      "Toyota Corolla Cross",
      42
    ]
  },
  "honda/cr-v": {
    "value": 40,
    "cls": "Small Sport Utility Vehicle 4WD",
    "rank": 4,
    "n": 70,
    "median": 27.0,
    "above": [
      "Toyota Corolla Cross",
      42
    ],
    "below": [
      "Toyota Venza",
      39
    ]
  },
  "subaru/forester": {
    "value": 35,
    "cls": "Small Sport Utility Vehicle 4WD",
    "rank": 10,
    "n": 70,
    "median": 27.0,
    "above": [
      "Lexus RX",
      36
    ],
    "below": [
      "Nissan Rogue",
      34
    ]
  },
  "subaru/outback": {
    "value": 29,
    "cls": "Small Sport Utility Vehicle 4WD",
    "rank": 20,
    "n": 70,
    "median": 27.0,
    "above": [
      "BMW X3",
      30
    ],
    "below": [
      "Fiat 500X",
      28
    ]
  },
  "jeep/wrangler": {
    "value": 25,
    "cls": "Small Sport Utility Vehicle 4WD",
    "rank": 43,
    "n": 70,
    "median": 27.0,
    "above": [
      "Buick Envision",
      26
    ],
    "below": [
      "Jaguar E-Pace",
      24
    ]
  },
  "ford/bronco": {
    "value": 21,
    "cls": "Small Sport Utility Vehicle 4WD",
    "rank": 66,
    "n": 70,
    "median": 27.0,
    "above": [
      "Honda Passport",
      22
    ],
    "below": [
      "Lincoln MKX",
      20
    ]
  },
  "ford/f150": {
    "value": 25,
    "cls": "Standard Pickup Trucks 2WD",
    "rank": 1,
    "n": 6,
    "median": 21.5,
    "above": null,
    "below": [
      "Toyota Tundra",
      22
    ]
  },
  "toyota/tundra": {
    "value": 22,
    "cls": "Standard Pickup Trucks 2WD",
    "rank": 3,
    "n": 6,
    "median": 21.5,
    "above": [
      "GMC Canyon",
      25
    ],
    "below": [
      "Nissan Frontier",
      21
    ]
  },
  "chevrolet/tahoe": {
    "value": 24,
    "cls": "Standard Sport Utility Vehicle 2WD",
    "rank": 7,
    "n": 14,
    "median": 23.5,
    "above": [
      "Jeep Grand Cherokee",
      25
    ],
    "below": [
      "Chevrolet Suburban",
      23
    ]
  },
  "toyota/4runner": {
    "value": 23,
    "cls": "Standard Sport Utility Vehicle 4WD",
    "rank": 17,
    "n": 52,
    "median": 22.5,
    "above": [
      "BMW X6",
      24
    ],
    "below": [
      "Audi Q7",
      22
    ]
  }
};

export const FUEL_BENCH: Record<string, Benchmark> = {
  "chevrolet/silverado": {
    "value": 26,
    "rank": 7,
    "n": 51,
    "median": 21.0,
    "above": [
      "Toyota Sequoia",
      26.4
    ],
    "below": [
      "Dodge Durango",
      24.6
    ],
    "ties": [
      "Chevrolet Tahoe",
      "GMC Sierra",
      "GMC Yukon",
      "Nissan Titan",
      "Nissan Armada",
      "Ram 1500"
    ]
  },
  "ford/f150": {
    "value": 23,
    "rank": 16,
    "n": 51,
    "median": 21.0,
    "above": [
      "Dodge Durango",
      24.6
    ],
    "below": [
      "Jeep Wrangler",
      22.5
    ],
    "ties": [
      "Toyota 4Runner"
    ]
  },
  "toyota/4runner": {
    "value": 23,
    "rank": 16,
    "n": 51,
    "median": 21.0,
    "above": [
      "Dodge Durango",
      24.6
    ],
    "below": [
      "Jeep Wrangler",
      22.5
    ],
    "ties": [
      "Ford F-150"
    ]
  },
  "jeep/wrangler": {
    "value": 22.5,
    "rank": 18,
    "n": 51,
    "median": 21.0,
    "above": [
      "Ford F-150",
      23
    ],
    "below": [
      "Chevrolet Traverse",
      22.4
    ],
    "ties": []
  },
  "toyota/tacoma": {
    "value": 21.1,
    "rank": 21,
    "n": 51,
    "median": 21.0,
    "above": [
      "Jeep Gladiator",
      22
    ],
    "below": [
      "GMC Canyon",
      21
    ],
    "ties": [
      "Nissan Frontier"
    ]
  },
  "subaru/outback": {
    "value": 18.5,
    "rank": 41,
    "n": 51,
    "median": 21.0,
    "above": [
      "Ford Explorer",
      18.6
    ],
    "below": [
      "Ford Ranger",
      18
    ],
    "ties": [
      "Ford Edge"
    ]
  },
  "toyota/rav4": {
    "value": 15.9,
    "rank": 46,
    "n": 51,
    "median": 21.0,
    "above": [
      "Subaru Forester",
      16.6
    ],
    "below": [
      "Ford Escape",
      15.7
    ],
    "ties": []
  },
  "honda/cr-v": {
    "value": 15.3,
    "rank": 48,
    "n": 51,
    "median": 21.0,
    "above": [
      "Ford Escape",
      15.7
    ],
    "below": [
      "Nissan Rogue",
      14.5
    ],
    "ties": [
      "Mazda CX-5"
    ]
  }
};

export const DIM_BENCH: Record<string, Benchmark> = {
  "chevrolet/tahoe": {
    "value": 210.6,
    "rank": 31,
    "n": 439,
    "median": 189.0,
    "above": [
      "Ford Ranger",
      211.0
    ],
    "below": [
      "Honda Ridgeline",
      210.2
    ],
    "ties": []
  },
  "toyota/rav4": {
    "value": 181.1,
    "rank": 316,
    "n": 439,
    "median": 189.0,
    "above": [
      "Pagani Huayra",
      181.5
    ],
    "below": [
      "Toyota RAV4 Prime",
      180.7
    ],
    "ties": []
  },
  "ford/escape": {
    "value": 180.7,
    "rank": 320,
    "n": 439,
    "median": 189.0,
    "above": [
      "Toyota RAV4",
      181.1
    ],
    "below": [
      "Chevrolet Volt",
      180.3
    ],
    "ties": []
  }
};

/**
 * NHTSA overall-star context: how many rated models in our own dataset earn
 * each score. Five stars is common, which is the point — it is not a
 * differentiator on its own.
 */
export const SAFETY_COHORT = { rated: 164, fiveStar: 132 };

export function benchFor(
  dataType: string,
  makeSlug: string,
  modelSlug: string,
): Benchmark | null {
  const key = `${makeSlug}/${modelSlug}`;
  if (dataType === "towing-capacity") return TOWING_BENCH[key] ?? null;
  if (dataType === "bed-dimensions") return BED_BENCH[key] ?? null;
  if (dataType === "mpg") return MPG_BENCH[key] ?? null;
  if (dataType === "fuel-tank-capacity") return FUEL_BENCH[key] ?? null;
  if (dataType === "dimensions") return DIM_BENCH[key] ?? null;
  return null;
}
